import React, {useCallback, useEffect, useState, useMemo, memo} from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
// import {logoutIc, logoutIcGrey} from '../assets/images/images';
// import * as Actions from '../store/actions';

import {useMediaQuery} from '../hooks';
import {Constants} from '../helpers';
import {MainSideNavigations} from './SideNavigations/MainSideNavigations';
import {ReconciloSideNavigations} from './SideNavigations/ReconciloSideNavigations';
import {usePermissions} from '../hooks/useSidbarPermissions';
import {version} from '../version';
import {TrypilaSideNavigations} from './SideNavigations/TrypilaSideNaviations';
import VeldroSideNavigation from './SideNavigations/VeldroSideNavigation';
import ProfiledRiskSideNavigations from './SideNavigations/ProfiledRiskSideNavigations';

const isReconcilo = localStorage?.getItem('subdomain')?.includes('reconcilo');
const isVeldro = localStorage?.getItem('subdomain')?.includes('veldro');
const isTrypila = localStorage?.getItem('subdomain')?.includes('trypila');
const isProfiledRisk = localStorage
  ?.getItem('subdomain')
  ?.includes('profiledrisk');

const SubSidebar = memo(() => {
  // const dispatch = useDispatch();
  const {pathname} = useLocation();
  const mediaQuery = useMediaQuery('(min-width: 1024px)');

  const media = useMemo(() => mediaQuery, [mediaQuery]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const toggleSubRoute = useCallback(routeKey => {
    setOpenDropdown(prevDropdown =>
      prevDropdown === routeKey ? null : routeKey,
    );
  }, []);
  useEffect(() => {
    if (openDropdown !== null) {
      sessionStorage.setItem('open_dropdown_item', openDropdown);
    }
  }, [openDropdown]);
  useEffect(() => {
    const savedOpenDropdown = sessionStorage.getItem('open_dropdown_item');
    setOpenDropdown(savedOpenDropdown ? savedOpenDropdown : null);
  }, []);

  const splitLocation = pathname.split('/');
  const environment = {production: 'P', development: 'D', staging: 'S'}[
    process.env.REACT_APP_APP_ENV_MODE
  ];

  return (
    <ul className="xl:px-3 md:pt-10 pt-6 lg:pt-0">
      {isReconcilo ? (
        <ReconciloSideNavigations
          media={media}
          openDropdown={openDropdown}
          pathname={pathname}
          splitLocation={splitLocation}
          toggleSubRoute={toggleSubRoute}
        />
      ) : isTrypila ? (
        <TrypilaSideNavigations
          media={media}
          openDropdown={openDropdown}
          pathname={pathname}
          splitLocation={splitLocation}
          toggleSubRoute={toggleSubRoute}
        />
      ) : isVeldro ? (
        <VeldroSideNavigation
          media={media}
          openDropdown={openDropdown}
          pathname={pathname}
          splitLocation={splitLocation}
          toggleSubRoute={toggleSubRoute}
        />
      ) : isProfiledRisk ? (
        <ProfiledRiskSideNavigations
          media={media}
          openDropdown={openDropdown}
          pathname={pathname}
          splitLocation={splitLocation}
          toggleSubRoute={toggleSubRoute}
        />
      ) : (
        <MainSideNavigations
          media={media}
          openDropdown={openDropdown}
          pathname={pathname}
          splitLocation={splitLocation}
          toggleSubRoute={toggleSubRoute}
        />
      )}

      {process.env.REACT_APP_APP_ENV_MODE !== 'production' && (
        <div className="w-full rounded text-white flex items-center gap-2 pl-4 py-2 lg:hovhover:bg-brandBlue40 er:bg-[#1c1d31]">
          <p className="text-xs text-grey30">
            v-{version} - {environment || 'D'}
          </p>
        </div>
      )}
    </ul>
  );
});

const SubDomainSettingsLayout = () => {
  const userDetails = useSelector(state => state?.auth?.userDetails);
  const {
    modularisation: {profile_services, teams_services},
  } = usePermissions();

  const USER_PERMISSIONS = useMemo(
    () => userDetails?.permissions,
    [userDetails],
  );

  return (
    <div className="py-3">
      <div className="rounded-md mt-4 bg-[#F7F7F7] w-fit p-1 flex items-center gap-2 overflow-x-auto">
        <div className="flex items-center gap-4 overflow-x-auto settings-nav whitespace-nowrap">
          {profile_services && (
            <NavLink
              end
              to={Constants.PAGES_URL.SETTINGS_PROFILE}
              className={({isActive}) =>
                `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                  isActive
                    ? 'text-black bg-white shadow-tabs'
                    : 'text-grey-500 bg-transparent'
                }`
              }
            >
              Profile
            </NavLink>
          )}
          {USER_PERMISSIONS?.role === 'Owner' && !isProfiledRisk && (
            <NavLink
              to={`/settings/company-verification`}
              className={({isActive}) =>
                `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                  isActive
                    ? 'text-black bg-white shadow-tabs'
                    : 'text-grey-500 bg-transparent'
                }`
              }
            >
              Company Verification
            </NavLink>
          )}

          {/*{USER_PERMISSIONS?.role === 'Owner' && (*/}
          <NavLink
            to={`/settings/email-notifications`}
            className={({isActive}) =>
              `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                isActive
                  ? 'text-black bg-white shadow-tabs'
                  : 'text-grey-500 bg-transparent'
              }`
            }
          >
            Email Notifications
          </NavLink>
          {/*)}*/}

          {(USER_PERMISSIONS?.role === 'Owner' ||
            Object.values(USER_PERMISSIONS?.settingsPermissions || {})?.some(
              p => !!p,
            )) && (
            <>
              {USER_PERMISSIONS?.settingsPermissions?.manageMembers &&
                teams_services &&
                !(isReconcilo || isTrypila || isVeldro) && (
                  <NavLink
                    to={`/settings/team`}
                    className={({isActive}) =>
                      `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                        isActive
                          ? 'text-black bg-white shadow-tabs'
                          : 'text-grey-500 bg-transparent'
                      }`
                    }
                  >
                    Team
                  </NavLink>
                )}
              {/* {audit_logs_services && (
              <NavLink
                to={`/settings/audit-logs`}
                className={({isActive}) =>
                  `font-medium text-sm py-2 ${
                    isActive
                      ? 'text-brandBlue border-b-2 border-brandBlue'
                      : 'text-grey30'
                  }`
                }
                style={{
                  pointerEvents: USER_PERMISSIONS?.settingsPermissions
                    ?.viewAndDownloadAudit
                    ? 'auto'
                    : 'none',
                }}
              >
                Audit Logs
              </NavLink>
            )} */}
              {/* {billings_services && !(isReconcilo || isTrypila) && (
              <NavLink
                to={`/billing`}
                className={({isActive}) =>
                  `font-medium text-sm py-2 ${
                    isActive
                      ? 'text-brandBlue border-b-2 border-brandBlue'
                      : 'text-grey30'
                  }`
                }
              >
                Billing
              </NavLink>
            )} */}
            </>
          )}

          {/* {isProfiledRisk && (
            <NavLink
              to={`/profiled-risk-configuration`}
              className={({isActive}) =>
                `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                  isActive
                    ? 'text-black bg-white shadow-tabs'
                    : 'text-grey-500 bg-transparent'
                }`
              }
            >
              Configuration
            </NavLink>
          )} */}
        </div>
      </div>
    </div>
  );
};

export {SubSidebar, SubDomainSettingsLayout};
